import { useData } from 'vike-react/useData'
import type { Data } from './+data'
import ProductDetailView from '../../src/ssr/product/ProductDetailView'
import { resolveVariant } from '../../src/ssr/product/resolveVariant'
import ProductSeoHead from '../../src/ssr/product/ProductSeoHead'
import { isFullVariantArray } from '../../src/ssr/product/variantGuards'
import type { Variant } from '../../src/types'

export default function ProductCanonicalPage() {
  const { lang, product, related, distributor_offers } = useData<Data>()
  // product.variants at the detail endpoint is always the full Variant shape;
  // the summary `ProductVariant` shape is only returned by the listing API.
  // The cross-endpoint type union lives in src/types/index.ts.
  const variants: Variant[] = isFullVariantArray(product.variants) ? product.variants : []
  const resolved = resolveVariant(variants, undefined)

  return (
    <>
      <ProductSeoHead
        lang={lang}
        product={product}
        variant={resolved.variant}
        variants={variants}
        isCanonicalPage
      />
      <ProductDetailView
        lang={lang}
        product={product}
        variants={variants}
        selected={resolved.variant}
        related={related}
        distributorOffers={distributor_offers}
      />
    </>
  )
}
